import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";
import { SyncModel, DataModel, SyncDataModel } from "./syncModel";
import Utils from "../utils";
import { Moment } from "moment";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { ContentType, ImageOrientation } from "../contentTypes";

/** right length of web_voucher_number after trim must be 18 singts */
export const WebVoucherNumberLength: number = 18;

export class WebVoucherBalanceViewModel {
  public balance: number;
  public discountBonus: number;
  public balanceBonus: number;
  public storageDate: string;
  public walletReferenceId: string;
  public isActive: boolean;
  public get showBalance(): boolean {
    return this.balance > 0.0;
  }
  public get showDiscountBonus(): boolean {
    return this.discountBonus > 0.0;
  }
  public get showBalanceBonus(): boolean {
    return this.balanceBonus > 0.0;
  }
}

export class WebVoucherBalance {
  public static ReadFromModel(me: WebVoucherBalance, model: WebVoucherBalanceDataModel): void {
    me.loaded = true;
    /** show as money (fix 2 decimals) */
    me.balance = model.balance;
    /** show as persentage (show variable decimals, if not zero) */
    me.discount_bonus = model.discount_bonus;
    /** show as money (fix 2 decimals) */
    me.balance_bonus = model.balance_bonus;
  }

  public loaded: boolean = false;
  public balance: number;
  public discount_bonus: number;
  public balance_bonus: number;
  public get show_balance(): boolean {
    return this.balance > 0.0 || !(this.show_discount_bonus && this.show_balance_bonus);
  }
  public get show_discount_bonus(): boolean {
    return this.discount_bonus > 0.0;
  }
  public get show_balance_bonus(): boolean {
    return this.balance_bonus > 0.0;
  }
}

// Requests
export class GetWebVoucherModel {
  public web_voucher_number: string;
  public location: number;
}

export class SetWebVoucherModel {
  public web_voucher_number: string;
}

export class RemoveWebVoucherModel {
  public web_voucher_number: string;
}

// Responses
export class GetWebVoucherDataModel implements ApiResponseData {
  public success: boolean;
  public cardnumber: string;
  public balance: number;
  public discount_bonus: number;
  public balance_bonus: number;
  DeserializeType(): void {
    // no complex data
  }
}

export class SetWebVoucherSuccessDataModel implements ApiResponseData {
  public success: boolean;
  DeserializeType(): void {
    // no complex data
  }
}

export class RemoveWebVoucherSuccessDataModel implements ApiResponseData {
  public success: boolean;
  DeserializeType(): void {
    // no complex data
  }
}

export class WebVoucherBalanceDataModel implements ApiResponseData {
  public balance: number;
  public discount_bonus: number;
  public balance_bonus: number;
  public wallet_reference_id: string;
  public wallet_active: boolean;
  DeserializeType(): void {
    // no complex data
  }
}

export class CreateWebVoucherDataModel implements ApiResponseData {
  public success: boolean;
  public cardnumber: string;
  public balance: number;
  public discount_bonus: number;
  public balance_bonus: number;
  public too_much_tries: boolean;
  DeserializeType(): void {
    // no complex data
  }
}

export class WebvoucherSyncModel extends SyncModel {
}

/** Webgutscheine für den Verkauf */
export class WebvoucherDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  /** für Verkauf aktiv */
  public active: boolean;
  public label_de: string;
  public label_en: string;
  /** Bezeichnung */
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.label_en) ? this.label_de : this.label_en;
  }
  public short_description_de: string;
  public short_description_en: string;
  /** Kurzbeschreibung */
  public get short_description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.short_description_en) ? this.short_description_de : this.short_description_en;
  }
  public long_description_html_de: string;
  public long_description_html_en: string;
  /** Langbeschreibung als HTML */
  public get long_description_html(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.long_description_html_en) ? this.long_description_html_de : this.long_description_html_en;
  }
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  /** Letzte aktualisierung des Images */
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  /** url zum bild, vorprüfung last_image_update_at_ymd > 0 notwendig  */
  public get image_photo(): string {
    return ContentType.Webvoucher_Custom + "/" + this.id + "_photo_" + ImageOrientation.Landscape + "/" + this.last_image_update_at_ymd + "/" + this.last_image_update_at_hms;
  }
  /** Gutscheinbetrag kann frei bestimmt werden */
  public is_free_amount: boolean;
  /** Gutschienbetrag, wenn fest, in Cents */
  public fix_amount_value: number;
  /** Gutschienbetrag, wenn fest */
  public get fix_amount(): number {
    return Utils.centsToCurrency(this.fix_amount_value);
  }
  /** Zugeordneter Layout */
  public layout_id: number;
  /** Sortierreihenfolge */
  public sort_no: number;
  /** Bereits gelöscht */
  public deleted: boolean;
}

export class WebvoucherSyncDataModel extends SyncDataModel {
  public webvouchers: WebvoucherDataModel[];
  public get models(): DataModel[] { return this.webvouchers; }
  public DeserializeType(): void {
    this._DeserializeType(WebvoucherDataModel);
  }
}

export class WebvoucherLayoutSyncModel extends SyncModel {
}

/** Webgutscheine für den Verkauf */
export class WebvoucherLayoutDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  /** Letzte aktualisierung des Images */
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  /** url zum bild, vorprüfung last_image_update_at_ymd > 0 notwendig  */
  public get image_photo(): string {
    return ContentType.Webvoucher_Layout_Preview + "/" + this.id + "_photo_" + ImageOrientation.Portrait + "/" + this.last_image_update_at_ymd + "/" + this.last_image_update_at_hms;
  }
}

export class WebvoucherLayoutSyncDataModel extends SyncDataModel {
  public webvoucher_layouts: WebvoucherLayoutDataModel[];
  public get models(): DataModel[] { return this.webvoucher_layouts; }
  public DeserializeType(): void {
    this._DeserializeType(WebvoucherLayoutDataModel);
  }
}

